var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$root.deals),function(deal){return _c('deal-list-row',{key:deal.id,attrs:{"deal":deal}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }